import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';

export default function isVoidHtmlElement(node: Node): node is TVoidHtmlElement {
    return isHtmlElementNode(node, 'HR') || isHtmlElementNode(node, 'IMG') || isHtmlElementNode(node, 'IFRAME');
}

// #region Types

export type TVoidHtmlElement =
    | (HTMLHRElement & { tagName: 'HR' })
    | (HTMLImageElement & { tagName: 'IMG' })
    | (HTMLIFrameElement & { tagName: 'IFRAME' });

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isVoidElement', () => {
        test('results with false for non-html elements', () => {
            expect(isVoidHtmlElement(document)).toBe(false);
            expect(isVoidHtmlElement(document.createTextNode('text'))).toBe(false);
        });

        test('results with true only for text-void html elements', () => {
            expect(isVoidHtmlElement(document.createElement('hr'))).toBe(true);
            expect(isVoidHtmlElement(document.createElement('img'))).toBe(true);
            expect(isVoidHtmlElement(document.createElement('iframe'))).toBe(true);
            expect(isVoidHtmlElement(document.createElement('p'))).toBe(false);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isVoidHtmlElement(node)
                ? expectTypeOf(node).toMatchTypeOf<HTMLHRElement | HTMLImageElement | HTMLIFrameElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHRElement | HTMLImageElement | HTMLIFrameElement>();
        });
    });
}

// #endregion
